import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { useWebVitals } from '@/hooks/useWebVitals';
import { ThemeProvider } from 'next-themes';
import { registerWebMcp } from '@/agent/registerWebMcp';

// This component initializes Web Vitals reporting.
// It does not render anything itself.
const WebVitalsReporter: React.FC = () => {
  useWebVitals();
  return null;
};

const container = document.getElementById('root');

registerWebMcp();

if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <ThemeProvider attribute="class" defaultTheme="dark" enableSystem storageKey="vite-ui-theme">
        <App />
        {/* Mount WebVitalsReporter here to activate it */}
        <WebVitalsReporter />
      </ThemeProvider>
    </React.StrictMode>
  );
} else {
  console.error('Failed to find the root element. Web Vitals will not be reported.');
}
